import {
  E_SOURCE_TYPE,
  type TOriginalSource,
  type TSoftTable,
  type TSourceData,
  type TSourceDataResult,
} from "../types/artifact-processing.types";


export default class ArtifactProcessingService<ProcessingType extends E_SOURCE_TYPE> {
  private artifactProcessingResult: TSoftTable | null = null;
  private originalSourceType: TOriginalSource = null;
  private sourceType: E_SOURCE_TYPE;

  private textArtifacts = ["\n", "\r", "\t", '"', "'", " ", "", "'"];

  constructor(private sourceData: TSourceData[ProcessingType]) {
    this.sourceType = this.getArtifactType();
  }

  public get result(): TSourceDataResult[ProcessingType] | null {
    if (!this.artifactProcessingResult) return null;

    if (this.originalSourceType === "array") {
      return this.artifactProcessingResult as TSourceDataResult[ProcessingType];
    } else if (this.originalSourceType === "object") {
      return this
        .artifactProcessingResult[0] as TSourceDataResult[ProcessingType];
    } else {
      return this.artifactProcessingResult as TSourceDataResult[ProcessingType];
    }
  }

  public process() {
    switch (this.sourceType) {
      case E_SOURCE_TYPE.JSON:
        const parsedData = JSON.parse(this.sourceData as string);
        this.setOriginalSourceType(parsedData);
        var preparedRawData = parsedData as TSoftTable;
        this.artifactProcessingResult = this.softTableScraping(preparedRawData);
        break;
      case E_SOURCE_TYPE.DICTIONARY:
        this.setOriginalSourceType(this.sourceData);
        var preparedRawData = [this.sourceData] as TSoftTable;
        this.artifactProcessingResult = this.softTableScraping(preparedRawData);
        break;
      case E_SOURCE_TYPE.ARRAY_OF_DICTIONARIES:
        this.setOriginalSourceType(this.sourceData);
        var preparedRawData = this.sourceData as TSoftTable;
        this.artifactProcessingResult = this.softTableScraping(preparedRawData);
        break;
      default:
        throw new Error("Unsupported artifact type");
    }
    return this.result;
  }

  private softTableScraping(rawTableData: TSoftTable): Record<string, any>[] {
    const tableData: Record<string, any>[] = [];

    for (let row of rawTableData) {
      const newRow: Record<string, any> = {};
      const columns = Object.keys(row);

      for (let col of columns) {
        const cell = row[col];

        if (!cell?.split) {
          newRow[col] = cell;
          continue;
        }

        const cellSymbols: string[] = cell.split("");
        const firstSymbolIndex: number = 0;
        const lastSymbolIndex: number = cellSymbols.length - 1;

        const firstSymbol = cellSymbols[firstSymbolIndex];
        const checkFirstSymbol = this.textArtifacts.includes(firstSymbol);
        if (checkFirstSymbol) {
          cellSymbols[firstSymbolIndex] = "";
        }

        const lastSymbol = cellSymbols[lastSymbolIndex];
        const checkLastSymbol = this.textArtifacts.includes(lastSymbol);
        if (checkLastSymbol) {
          cellSymbols[lastSymbolIndex] = "";
        }

        const updatedCell = cellSymbols.join("");
        newRow[col] = updatedCell;
      }
      tableData.push(newRow);
    }

    return tableData;
  }

  private setOriginalSourceType(source: any) {
    if (source) {
      this.originalSourceType = Array.isArray(source) ? "array" : "object";
    } else {
      this.originalSourceType = null;
    }
  }

  private getArtifactType(): E_SOURCE_TYPE {
    if (typeof this.sourceData === "string") {
      return E_SOURCE_TYPE.JSON;
    } else if (Array.isArray(this.sourceData)) {
      return E_SOURCE_TYPE.ARRAY_OF_DICTIONARIES;
    } else if (this.sourceData instanceof Object) {
      return E_SOURCE_TYPE.DICTIONARY;
    } else {
      throw new Error("Unsupported artifact type");
    }
  }
}
